export default __webpack_public_path__ + "static/ITCAvantGardeStd-Demi-29247e8cd879bc89040e39173841de77.woff";